<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-02",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 22,
      nextPage: '/questionnaire/section2/3',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/25-Immunity.png'),
        mainTitle: 'Do you often feel weak, tired, or sluggish?',
        btn: [
          [
            {
              text: 'More than 3 times a week',
            }
          ],[
            {
              text: '1-2 times a week',
            }
          ],[
            {
              text: 'Never',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
